import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import {Tooltip} from '@wandb/weave/components/Tooltip';
import {maybePluralize} from '@wandb/weave/core/util/string';
import React from 'react';

import {UserAccountType} from '../../../../generated/graphql';
import {QueryTeamMember} from './types';

const PREVIEW_LIMIT = 10;

export const TeamMembersPreviewTooltip = ({
  members,
  numUsers,
}: {
  members: QueryTeamMember[];
  numUsers: number;
}) => {
  if (numUsers === 0) {
    return <span>{maybePluralize(numUsers, 'user')}</span>;
  }
  let slicedMembers = members;
  if (members.length > PREVIEW_LIMIT) {
    slicedMembers = members?.slice(0, PREVIEW_LIMIT);
  }
  return (
    <Tooltip
      position="right center"
      trigger={<span>{maybePluralize(numUsers, 'user')}</span>}>
      <Tailwind>
        <div className="grid items-center gap-y-8">
          {slicedMembers.map(m => {
            return (
              <div key={m.id} className="flex items-center gap-8">
                {m.accountType !== UserAccountType.OrgService ? (
                  <img
                    src={m.photoUrl ?? '/default-profile-picture.png'}
                    className="h-24 w-24 rounded-full"
                    alt=""
                    height="24"
                    width="24"
                  />
                ) : (
                  <div className="content-center justify-center rounded-full bg-moon-900 bg-opacity-[.32] p-4 align-middle">
                    <Icon
                      name="robot-service-member"
                      className="h-16 w-16 text-teal-400"
                    />
                  </div>
                )}
                <div className="text-sm leading-[19.6px]">{m.name}</div>
              </div>
            );
          })}
          {slicedMembers.length < members.length && (
            <div className="text-sm leading-[19.6px]">
              + {members?.length - PREVIEW_LIMIT} more
            </div>
          )}
        </div>
      </Tailwind>
    </Tooltip>
  );
};
